module.exports = __webpack_public_path__ + "img/amazon-logo.15a1c610.png";